import { CKEditor } from '@ckeditor/ckeditor5-react';
import React, { FC } from 'react';

import { HTMLEditorProps } from './types';

const Component: FC<HTMLEditorProps> = React.memo((props) => {
    const { disabled = false, value = '', onChange, editor, ...restProps } = props;
    return (
        <CKEditor disabled={disabled} data={value || ''} editor={editor} onChange={(ev, editor) => onChange(ev, editor)} {...restProps} />
    );
});
Component.displayName = 'HTMLEditor';
export const HTMLEditor: FC<HTMLEditorProps> = Object.assign(Component, {});
